import { alpha, createTheme } from '@mui/material/styles';

const defaultTheme = createTheme();

const customShadows = [...defaultTheme.shadows];

const AppBarLight = 'hsla(34, 43.50%, 72.90%, 0.4);';
const AppBarDark = 'hsla(34, 44%, 39%,0.4);';
/* #2E3841 (sötét árnyalat) */
export const brand = {
  50: 'hsl(34, 44%, 95%);',
  100: 'hsl(34, 44%, 80%);',
  200: 'hsl(34, 44%, 73%);',
  300: 'hsl(34, 44%, 63%);',
  400: 'hsl(34, 44%, 55%);',
  500: 'hsl(34, 44%, 45%);',
  600: 'hsl(34, 44%, 39%);',
  700: 'hsl(34, 44%, 28%);',
  800: 'hsl(34, 44%, 19%);',
  900: 'hsl(34, 44%, 10%);',
};
/* #4A596C (közepesen sötét kékesszürke) */
export const blue = {
  50: 'hsl(193, 94%, 95%)',
  100: 'hsl(193, 94%, 86%)',
  200: 'hsl(193, 70%, 75%)',
  300: 'hsl(193, 70%, 60%)',
  400: 'hsl(193, 70%, 50%)',
  500: 'hsl(193, 50%, 50%)',
  600: 'hsl(193, 60%, 50%)',
  700: 'hsl(193, 70%, 40%)',
  800: 'hsl(193, 80%, 40%)',
  900: 'hsl(193, 100.00%, 30%)',
};
/* #6E7C8A: hsl(210, 20%, 54%) (szürkéskék) */
export const gray = {
  50: 'hsl(210, 80%, 95.00%)',
  100: 'hsl(210, 66%, 87%)',
  200: 'hsl(210, 60%, 80%)',
  300: 'hsl(210, 60%, 70%)',
  400: 'hsl(210, 50%, 60%)',
  500: 'hsl(210, 50%, 50%)',
  600: 'hsl(210, 45%, 40%)',
  700: 'hsl(210, 50%, 30%)',
  800: 'hsl(210, 50%, 20%)',
  900: 'hsl(210, 60.00%, 10%)',
};

export const green = {
  50: 'hsl(120, 80%, 98%)',
  100: 'hsl(120, 75%, 94%)',
  200: 'hsl(120, 75%, 87%)',
  300: 'hsl(120, 61%, 77%)',
  400: 'hsl(120, 44%, 53%)',
  500: 'hsl(120, 59%, 30%)',
  600: 'hsl(120, 70%, 25%)',
  700: 'hsl(120, 75%, 16%)',
  800: 'hsl(120, 84%, 10%)',
  900: 'hsl(120, 87%, 6%)',
};

export const orange = {
  50: 'hsl(38, 100%, 97%)',
  100: 'hsl(38, 92%, 90%)',
  200: 'hsl(38, 94%, 80%)',
  300: 'hsl(38, 90%, 65%)',
  400: 'hsl(38, 90%, 40%)',
  500: 'hsl(38, 90%, 35%)',
  600: 'hsl(38, 91%, 25%)',
  700: 'hsl(38, 94%, 20%)',
  800: 'hsl(38, 95%, 16%)',
  900: 'hsl(38, 93%, 12%)',
};
/* #A8ACB0: hsl(209, 4%, 69%) (világos szürkéskék) */
export const highlighted = {
  50: 'hsl(0, 76%, 95%)',
  100: 'hsl(0, 76%, 85%)',
  200: 'hsl(0, 76%, 75%)',
  300: 'hsl(0, 76.40%, 65.10%)',
  400: 'hsl(0, 76%, 55%)',
  500: 'hsl(0, 76%, 45%)',
  600: 'hsl(0, 76%, 35%)',
  700: 'hsl(0, 76%, 25%)',
  800: 'hsl(0, 76%, 15%))',
  900: 'hsl(0, 76%, 5%)',
};

export const getDesignTokens = (mode) => {
  customShadows[1] =
    mode === 'dark'
      ? 'hsla(220, 30%, 5%, 0.7) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.8) 0px 8px 16px -5px'
      : 'hsla(220, 30%, 5%, 0.07) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.07) 0px 8px 16px -5px';

  return {
    palette: {
      mode,
      primary: {
        light: brand[100],
        main: brand[400],
        dark: brand[700],
        highlight: highlighted[400],
        contrastText: brand[50],
        ...(mode === 'dark' && {
          contrastText: brand[50],
          light: brand[300],
          main: brand[400],
          dark: brand[700],
          highlight: highlighted[400],
        }),
      },
      info: {
        light: brand[100],
        main: brand[300],
        dark: brand[600],
        contrastText: gray[50],
        ...(mode === 'dark' && {
          contrastText: brand[300],
          light: brand[500],
          main: brand[700],
          dark: brand[900],
        }),
      },
      warning: {
        light: orange[300],
        main: orange[400],
        dark: orange[800],
        ...(mode === 'dark' && {
          light: orange[400],
          main: orange[500],
          dark: orange[700],
        }),
      },
      error: {
        light: highlighted[300],
        main: highlighted[400],
        dark: highlighted[800],
        ...(mode === 'dark' && {
          light: highlighted[400],
          main: highlighted[500],
          dark: highlighted[700],
        }),
      },
      success: {
        light: green[300],
        main: green[400],
        dark: green[800],
        ...(mode === 'dark' && {
          light: green[400],
          main: green[500],
          dark: green[700],
        }),
      },
      grey: {
        ...gray,
      },
      divider: mode === 'dark' ? alpha(gray[700], 0.6) : alpha(gray[300], 0.4),
      background: {
        default: brand[50],
        paper: brand[300],
        backButton: orange[300],
        appBar: AppBarLight,
        ...(mode === 'dark' && {
          default: brand[800],
          paper: 'hsl(220, 30%, 7%)',
          backButton: orange[300],
          appBar: AppBarDark,
        }),
      },
      text: {
        primary: brand[900],
        secondary: gray[600],
        warning: highlighted[400],
        ...(mode === 'dark' && {
          primary: 'hsl(0, 0%, 100%)',
          secondary: gray[400],
        }),
      },
      action: {
        hover: alpha(gray[200], 0.2),
        selected: `${alpha(gray[200], 0.3)}`,
        ...(mode === 'dark' && {
          hover: alpha(gray[600], 0.2),
          selected: alpha(gray[600], 0.3),
        }),
      },
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',
      h1: {
        fontSize: defaultTheme.typography.pxToRem(48),

        fontWeight: 600,
        lineHeight: 1.2,
        letterSpacing: -0.5,
      },
      h2: {
        fontSize: defaultTheme.typography.pxToRem(36),
        fontWeight: 600,
        lineHeight: 1.2,
      },
      h3: {
        fontSize: defaultTheme.typography.pxToRem(30),
        lineHeight: 1.2,
      },
      h4: {
        fontSize: defaultTheme.typography.pxToRem(24),
        fontWeight: 600,
        lineHeight: 1.5,
      },
      h5: {
        fontSize: defaultTheme.typography.pxToRem(20),
        fontWeight: 600,
      },
      h6: {
        fontSize: defaultTheme.typography.pxToRem(8),
        fontWeight: 600,
      },
      subtitle1: {
        fontSize: defaultTheme.typography.pxToRem(18),
      },
      subtitle2: {
        fontSize: defaultTheme.typography.pxToRem(14),
        fontWeight: 500,
      },
      body1: {
        fontSize: defaultTheme.typography.pxToRem(14),
      },
      body2: {
        fontSize: defaultTheme.typography.pxToRem(14),
        fontWeight: 400,
      },
      caption: {
        fontSize: defaultTheme.typography.pxToRem(12),
        fontWeight: 400,
      },
      blockquote: {
        fontStyle: 'italic',
        fontSize: '1rem',
        lineHeight: 1.5,
        textAlign: 'center',
        maxWidth: 400,
        margin: '1rem auto',
        padding: '0.5rem 1rem',
        borderLeft: '4px solid',
        borderColor: 'primary.main',
        backgroundColor: (theme) =>
          (theme.vars || theme).palette.background.default,
        color: (theme) => (theme.vars || theme).palette.text.secondary,
      },
    },
    shape: {
      borderRadius: 8,
    },
    shadows: customShadows,
  };
};

export const colorSchemes = {
  light: {
    palette: {
      primary: {
        light: brand[100],
        main: brand[400],
        dark: brand[700],
        contrastText: brand[50],
        highlight: highlighted[400],
      },
      secondary: {
        light: orange[200],
        main: orange[400],
        dark: orange[700],
        contrastText: orange[50],
      },
      heading: {
        light: blue[200],
        main: blue[400],
        dark: blue[700],
        contrastText: blue[50],
      },
      info: {
        light: brand[100],
        main: brand[300],
        dark: brand[600],
        contrastText: gray[50],
      },
      warning: {
        light: orange[300],
        main: orange[400],
        dark: orange[800],
      },
      error: {
        light: highlighted[300],
        main: highlighted[400],
        dark: highlighted[800],
      },
      success: {
        light: green[300],
        main: green[400],
        dark: green[800],
      },
      grey: {
        ...gray,
      },
      divider: alpha(gray[300], 0.4),
      background: {
        default: brand[50],
        paper: 'hsl(220, 35%, 97%)',
        backButton: orange[300],
        appBar: AppBarLight,
      },
      text: {
        primary: brand[800],
        secondary: orange[600],
        warning: highlighted[400],
      },
      action: {
        hover: alpha(gray[200], 0.2),
        selected: `${alpha(gray[200], 0.3)}`,
      },
      baseShadow:
        'hsla(220, 30%, 5%, 0.07) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.07) 0px 8px 16px -5px',
    },
  },
  dark: {
    palette: {
      primary: {
        contrastText: brand[50],
        light: brand[300],
        main: brand[400],
        dark: brand[700],
        highlight: highlighted[400],
      },
      secondary: {
        light: orange[200],
        main: orange[400],
        dark: orange[700],
        contrastText: orange[50],
      },
      heading: {
        light: blue[100],
        main: blue[400],
        dark: blue[700],
        contrastText: blue[50],
      },
      info: {
        contrastText: brand[300],
        light: brand[500],
        main: brand[700],
        dark: brand[900],
      },
      warning: {
        light: orange[400],
        main: orange[500],
        dark: orange[700],
      },
      error: {
        light: highlighted[400],
        main: highlighted[500],
        dark: highlighted[700],
      },
      success: {
        light: green[400],
        main: green[500],
        dark: green[700],
      },
      grey: {
        ...gray,
      },
      divider: alpha(gray[700], 0.6),
      background: {
        default: brand[700],
        paper: 'hsl(220, 30%, 7%)',
        backButton: orange[300],
        appBar: AppBarDark,
      },
      text: {
        primary: brand[50],
        secondary: orange[400],
      },
      action: {
        hover: alpha(gray[600], 0.2),
        selected: alpha(gray[600], 0.3),
      },
      baseShadow:
        'hsla(220, 30%, 5%, 0.7) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.8) 0px 8px 16px -5px',
    },
  },
};

export const typography = {
  fontFamily: 'Roboto, sans-serif',
  h1: {
    fontSize: defaultTheme.typography.pxToRem(48),

    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: -0.5,
  },
  h2: {
    fontSize: defaultTheme.typography.pxToRem(36),
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: defaultTheme.typography.pxToRem(30),
    lineHeight: 1.2,
  },
  h4: {
    fontSize: defaultTheme.typography.pxToRem(24),
    fontWeight: 600,
    lineHeight: 1.5,
  },
  h5: {
    fontSize: defaultTheme.typography.pxToRem(20),
    fontWeight: 600,
  },
  h6: {
    fontSize: defaultTheme.typography.pxToRem(14),
    fontWeight: 600,
  },
  subtitle1: {
    fontSize: defaultTheme.typography.pxToRem(18),
  },
  subtitle2: {
    fontSize: defaultTheme.typography.pxToRem(14),
    fontWeight: 500,
  },
  subtitle3: {
    fontSize: defaultTheme.typography.pxToRem(14),
    fontWeight: 700,
  },
  body1: {
    fontSize: defaultTheme.typography.pxToRem(14),
  },
  body2: {
    fontSize: defaultTheme.typography.pxToRem(14),
    fontWeight: 400,
  },
  caption: {
    fontSize: defaultTheme.typography.pxToRem(12),
    fontWeight: 400,
  },
  blockquote: {
    fontStyle: 'italic',
    fontSize: '1rem',
    lineHeight: 1.5,
    textAlign: 'center',
    maxWidth: 400,
    margin: '1rem auto',
    padding: '0.5rem 1rem',
    borderLeft: '4px solid',
    borderColor: 'primary.main',
    backgroundColor: (theme) =>
      (theme.vars || theme).palette.background.default,
    color: (theme) => (theme.vars || theme).palette.text.secondary,
  },
};

export const shape = {
  borderRadius: 8,
};

const defaultShadows = [
  'none',
  'var(--template-palette-baseShadow)',
  ...defaultTheme.shadows.slice(2),
];

export const shadows = defaultShadows;
